import { fetchWithAcceptHeaders } from '../utils/flowBuilderGridFetch';
import { getStaticBaseUrl } from '../utils/publicUrl';
const DEFAULT_WV_BRANDING = {
    wvAssetBase: '/images/WestVirginia/2026.03.27_One-Stop Shop Website',
    wvStateSealPng: '/images/WestVirginia/2026.03.27_One-Stop Shop Website/WVstateSeal.png',
    wvStateSealOneColorPng: '/images/WestVirginia/2026.03.27_One-Stop Shop Website/Governor_s Seal 2.png',
    oneStopShopTitleGraphicPng: '/images/WestVirginia/2026.03.27_One-Stop Shop Website/One Stop Shop Graphic.png',
    wvHeroCapitolDomeJpg: '/images/WestVirginia/2026.03.27_One-Stop Shop Website/West_Virginia_State_Capitol_-_Charleston__1_.webp',
    wvWhyChooseRiverCapitolJpg: '/images/WV/West-Virginia-Captiol.webp',
    wvPhotoCharlestonDowntownJpg: '/images/WestVirginia/2026.03.27_One-Stop Shop Website/013_FifeBrewery_220823_2615.webp',
    wvPhotoNewRiverGorgeJpg: '/images/WestVirginia/2026.03.27_One-Stop Shop Website/C.-Loomis-New-River-Gorge-LR--4-.webp',
    wvPhotoCharlestonHighwayJpg: '/images/WestVirginia/2026.03.27_One-Stop Shop Website/DJI_0036.webp',
};
const WV_KEYS = Object.keys(DEFAULT_WV_BRANDING);
let cachedWvBranding = null;
let wvBrandingPromise = null;
function mergeBranding(over) {
    const out = { ...DEFAULT_WV_BRANDING };
    for (const k of WV_KEYS) {
        const v = over[k];
        if (typeof v === 'string' && v.trim())
            out[k] = v.trim();
    }
    return out;
}
/** Synchronous read after `loadWvBrandingConfig` has resolved (app bootstraps after load). */
export function getCachedWvBranding() {
    return cachedWvBranding;
}
/** One-color seal path for watermarks — never throws; uses defaults until JSON is cached. */
export function getWvSealOneColorPath() {
    return getWvBrandingSafe().wvStateSealOneColorPng;
}
/**
 * Full branding object — never throws. Uses cached `wvBranding.json` after load, otherwise
 * built-in defaults (same paths as fetch error fallback). Prefer this in components so
 * defaults in props / module order cannot run before `loadWvBrandingConfig()` completes.
 */
export function getWvBrandingSafe() {
    return getCachedWvBranding() ?? DEFAULT_WV_BRANDING;
}
/**
 * Throws if branding JSON has not been loaded yet. Rarely needed; prefer {@link getWvBrandingSafe}.
 */
export function getWvBranding() {
    if (!cachedWvBranding) {
        throw new Error('WV branding not loaded; ensure loadWvBrandingConfig() completes before render.');
    }
    return cachedWvBranding;
}
export async function loadWvBrandingConfig() {
    if (cachedWvBranding)
        return cachedWvBranding;
    if (wvBrandingPromise)
        return wvBrandingPromise;
    const base = getStaticBaseUrl().replace(/\/?$/, '/');
    const url = `${base}wvBranding.json`;
    wvBrandingPromise = fetchWithAcceptHeaders(url)
        .then(async (res) => {
        if (!res.ok) {
            cachedWvBranding = DEFAULT_WV_BRANDING;
            return cachedWvBranding;
        }
        const json = (await res.json());
        cachedWvBranding = mergeBranding(json);
        return cachedWvBranding;
    })
        .catch(() => {
        cachedWvBranding = DEFAULT_WV_BRANDING;
        return cachedWvBranding;
    })
        .finally(() => {
        wvBrandingPromise = null;
    });
    return wvBrandingPromise;
}
